/**
 * This class is used to pull unique question and asnwer mappings
 */
const UTILITY_REFS = new Set([
  "utility_on",   // Ontario
  "utility_bc",   // British Columbia
  "utility_nb",   // New Brunswick
  "utility_ns",   // Nova Scotia
  "utility_nl",   // Newfoundland and Labrador
]);

/**
 * Map of utility field IDs if required
 */
const UTILITY_FIELD_IDS = new Set([
  "eeaCSdrhigcg", // Ontario
  "auBmkV8occpp", // British Columbia
  "cZckuILhqWGz", // New Brunswick
  "kX3Ed5WkJXyE", // Nova Scotia
  "bpeSX0qDaeRn", // Newfoundland and Labrador
]);

/**
 * Map utility field refs to provinces
 */
const UTILITY_REF_TO_PROVINCE = {
  utility_on: "ON",
  utility_bc: "BC",
  utility_nb: "NB",
  utility_ns: "NS",
  utility_nl: "NL",
};

/**
 * Extract quiz_utility
 *
 * @param {Object} answersMap
 * @param {Array} answers
 * @returns {Object}
 */
export const extractQuizUtility = (answersMap = {}, answers = []) => {
  let utilityValue = null;
  let sourceRef = null;

  for (const ref of UTILITY_REFS) {
    if (answersMap[ref]) {
      utilityValue = answersMap[ref];
      sourceRef = ref;
      break;
    }
  }

  if (!utilityValue && answers.length > 0) {
    const utilityAnswer = answers.find((answer) =>
      answer?.field?.id && UTILITY_FIELD_IDS.has(answer.field.id)
    );

    if (utilityAnswer) {
      sourceRef = utilityAnswer.field.ref;
      const selectedLabels = utilityAnswer.choices?.labels || 
        (utilityAnswer.choice?.label ? [utilityAnswer.choice.label] : []);
      utilityValue = selectedLabels.join(", ");
    }
  }

  return {
    quiz_utility: utilityValue || "",
    quiz_utility_province: sourceRef ? UTILITY_REF_TO_PROVINCE[sourceRef] : null,
    quiz_utility_source_ref: sourceRef,
  };
};

/**
 * Extract electrical panel
 *
 * @param {Object} answersMap
 * @returns {Object}
 */
export const extractElectricalPanelSize = (answersMap = {}) => {
  const panelValue = answersMap.electric_panel || "";

  return {
    quiz_electrical_panel_size: panelValue,
  };
};

/**
 * Extract all values dynamically
 *
 * @param {Object} answersMap
 * @param {Array} answers
 * @returns {Object}
 */
export const extractQuizMetafields = (answersMap = {}, answers = []) => {
  const utility = extractQuizUtility(answersMap, answers);
  const panel = extractElectricalPanelSize(answersMap);

  return {
    ...utility,
    ...panel,
  };
};
